<div class="page-overlay-wrapper" *ngIf="datas == 'on'">
  <div class="spinner_cls">

    <div class="tiles-wrap">
      <div class="tile" *ngFor="let letter of letters; let i = index"
           [style.animation-delay]="(i * 0.1) + 's'"
           [style.background]="tileGradient"
           [style.border-color]="tileBorder"
           [style.box-shadow]="'0 4px 0 ' + tileShadow + ', 0 6px 10px rgba(0,0,0,0.2)'">
        {{ letter }}
      </div>
    </div>

    <p class="loading-text" [style.color]="accentColor">Loading, please wait...</p>

  </div>
</div>